module.exports = __webpack_public_path__ + "media/images/talent/lp/ambassador/episode02-533c86cd3de653835da01b0b960f092d.jpg";